import { isNative } from './platform';

/**
 * Check and request filesystem write permission on native platforms.
 * Returns true if permission is granted (or not needed on web).
 */
export async function ensureStoragePermission(): Promise<boolean> {
    if (!isNative()) return true;

    const { Filesystem } = await import('@capacitor/filesystem');

    let status = await Filesystem.checkPermissions();
    if (status.publicStorage === 'granted') return true;

    // Prompt the user
    status = await Filesystem.requestPermissions();
    return status.publicStorage === 'granted';
}
